import { PropsWithChildren } from "react";

export const Section = ({
  className = "",
  title,
  children
}: PropsWithChildren & {
  title: string;
  className?: string;
}) => {
  return (
    <div className={className}>
      <h2 className="text-sm font-bold text-content-1000">{title}</h2>

      <div className="mb-4 mt-2 border-b border-alpha-100" />

      <div className="max-w-[816px]">{children}</div>
    </div>
  );
};
